// extracted by mini-css-extract-plugin
export default {"header":"titleValueGrid_header__+0PQV","hidden":"titleValueGrid_hidden__JfRbA","itemContainer":"titleValueGrid_itemContainer__oJSKz"};